import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { errorLogger } from "@/lib/errorLogger";

const MODULE_PATH_MAP: Record<string, string> = {
  "/warehouse": "warehouse", "/manufacturing": "manufacturing",
  "/quality": "quality", "/npd": "npd", "/purchasing": "purchasing",
  "/crm": "crm", "/admin": "admin", "/equipment": "equipment",
  "/training": "training", "/documents": "documents",
  "/suppliers": "suppliers", "/stock-items": "stock_items",
  "/planning": "planning", "/tasks": "tasks", "/messages": "messages",
  "/ai-chat": "ai_chat", "/proofing": "proofing", "/marketing": "marketing",
};

function inferModule(pathname: string): string {
  for (const [prefix, mod] of Object.entries(MODULE_PATH_MAP)) {
    if (pathname.startsWith(prefix)) return mod;
  }
  return pathname === "/" ? "dashboard" : "unknown";
}

export function useErrorBreadcrumbs(): void {
  const location = useLocation();
  useEffect(() => {
    errorLogger.addBreadcrumb("navigation", location.pathname);
    // Keep Sentry tags current so every error is tagged with the active module
    const module = inferModule(location.pathname);
    Sentry.setTag("qf.module", module);
    Sentry.setTag("qf.route", location.pathname);
  }, [location.pathname]);
}
